import { Alert, Stack, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import CopyToBufferButton from "@entrilia/shared/components/inputs/CopyToBufferButton";
import { getSmtpSettingRows, type ProvisionedSmtpAccount } from "./smtpSettings";

interface Props {
  account: ProvisionedSmtpAccount;
}

const SmtpSettingsPanel = ({ account }: Props) => (
  <Stack spacing={2}>
    <Typography>Set up this email account in Business Central with these values.</Typography>
    <Alert severity="warning">Copy the password now. It cannot be shown again, only reset.</Alert>
    <Table size="small">
      <TableBody>
        {getSmtpSettingRows(account).map((row) => (
          <TableRow key={row.label}>
            <TableCell>{row.label}</TableCell>
            <TableCell>
              <Typography sx={{ fontFamily: "monospace" }}>{row.value}</Typography>
            </TableCell>
            <TableCell>
              <CopyToBufferButton textToCopy={row.value} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Stack>
);

export default SmtpSettingsPanel;
